export default "__VITE_ASSET__be98434d__"